import type { MessageTrend } from '@/services/dashboardApi'

export interface MessageTrendSparklineProps {
  points?: MessageTrend[]
  days: number
  loading?: boolean
}

/** Línea pequeña de mensajes (entrantes + salientes) por día. Sin datos: texto, no una línea vacía. */
export function MessageTrendSparkline({ points, days, loading }: MessageTrendSparklineProps) {
  if (loading) {
    return <div className="mt-2 h-7 w-full animate-pulse rounded bg-slate-100" aria-hidden="true" />
  }

  const series = (points ?? []).map((point) => Number(point.inbound) + Number(point.outbound))
  const hasTrend = series.length >= 2 && series.some((value) => value > 0)

  if (!hasTrend) {
    return <p className="mt-2 text-xs text-slate-400">Sin tendencia de los últimos {days} días</p>
  }

  const width = 120
  const height = 28
  const max = Math.max(...series)
  const step = width / (series.length - 1)
  const coordinates = series
    .map((value, index) => {
      const x = Math.round(index * step)
      const y = Math.round(height - 3 - (value / max) * (height - 6))
      return `${x},${y}`
    })
    .join(' ')
  const total = series.reduce((sum, value) => sum + value, 0)

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      className="mt-2 h-7 w-full text-brand"
      role="img"
      aria-label={`Tendencia de ${total.toLocaleString()} mensajes en los últimos ${days} días`}
      preserveAspectRatio="none"
    >
      <polyline
        points={coordinates}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
